import { Modal } from "@design-lab/shared/ui/modal";
import { X } from "lucide-react";

interface RemoveConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function RemoveConfirmationModal({
  isOpen,
  onClose,
  onConfirm
}: RemoveConfirmationModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="h-auto w-full max-w-[375px]"
      title="Remove this image?"
      description="Confirm removal of uploaded image"
    >
      <div className="relative rounded-lg bg-white p-4">
        {/* Header */}
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-bold text-gray-800">Remove this image?</h2>
          <button
            type="button"
            onClick={onClose}
            className="flex size-6 items-center justify-center rounded hover:bg-gray-100"
            aria-label="Close"
            data-testid="remove-confirmation-close"
          >
            <X className="size-4 text-gray-500" />
          </button>
        </div>

        {/* Body */}
        <p className="mb-6 text-base text-gray-600">
          Disabling this will undo all background edits you&apos;ve made. Do you want to continue?
        </p>

        {/* Footer */}
        <div className="flex gap-2">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 rounded border border-gray-300 bg-white py-3 text-center font-medium text-gray-700 hover:bg-gray-50"
            data-testid="remove-confirmation-cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex-1 rounded bg-red-600 py-3 text-center font-medium text-white hover:bg-red-700"
            data-testid="remove-confirmation-confirm"
          >
            Remove
          </button>
        </div>
      </div>
    </Modal>
  );
}
